<div class="modal-header">
    <button type="button" class="btn btn-sm btn-danger pull-right" data-dismiss="dialog" (click)="cancel()"> 
      <fa-icon [icon]="faTimes"></fa-icon>
    </button>
      <h2>Template Preview</h2>
    </div>
<div style="margin:0 auto; width: 90%; overflow-x: scroll !important;" [innerHtml]="template | stringToHtml"></div>